var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout md-alignment-top-center md-gutter" },
    [
      _c("div", { staticClass: "md-layout-item md-size-45" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-dark btn-lg btn-block",
            on: { click: _vm.back }
          },
          [_vm._v(_vm._s(_vm.backBtnTitle))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout-item md-size-45" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-lg btn-block",
            on: { click: _vm.next }
          },
          [_vm._v(_vm._s(_vm.nextBtnTitle))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f7cd812", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f7cd812","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/parts/ButtonBar.vue
// module id = null
// module chunks = 